import { combineReducers } from 'redux';

import {
  LAST_PIPELINE_EVENT_CHANGED,
  PIPELINE_EVENTS_CHANGED,
  UNSEEN_PIPELINE_EVENTS_CHANGED,
  PIPELINE_EVENTS_LOADING_CHANGED
} from '../constants';

const fetchPipelineEventsForArtistOnInit = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const unseenPipelineEvents = (state = [], action) => {
  switch (action.type) {
    case UNSEEN_PIPELINE_EVENTS_CHANGED:
      return action.pipelineEvents;
    default:
      return state;
  }
};

const artist = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const pipelineEvents = (state = [], action) => {
  switch (action.type) {
    case PIPELINE_EVENTS_CHANGED:
      return action.pipelineEvents;
    default:
      return state;
  }
};

const pipelineEventsLoading = (state = false, action) => {
  switch (action.type) {
    case PIPELINE_EVENTS_LOADING_CHANGED:
      return action.isLoading;
    default:
      return state;
  }
};

const activityFeedReducer = combineReducers({ csrfToken, currentUser, pipelineEvents, team, artist, fetchPipelineEventsForArtistOnInit, unseenPipelineEvents, pipelineEventsLoading });

export default activityFeedReducer;
